import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=46c7b794"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c7b794')) {
      api.createRecord('46c7b794', component.options)
    } else {
      api.reload('46c7b794', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=46c7b794", function () {
      api.rerender('46c7b794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabs/Tab.vue"
export default component.exports